import dynamic from 'next/dynamic';
import React from 'react';
import { PLATFORM } from '../../constants/platforms';
import { withPlatForm } from '../../utils/matcher/matcher';

const MobileMovieInfo = dynamic(() => import('./MobileMovieInfo'));
const DesktopMovieInfo = dynamic(() => import('./DesktopMovieInfo'));

const MovieInfo = (props) => {
	return (
		<>
			{withPlatForm([
				{
					platform: [PLATFORM.H5, PLATFORM.M_WEB],
					component: <MobileMovieInfo {...props} />,
				},
				{
					platform: [PLATFORM.D_WEB],
					component: <DesktopMovieInfo {...props} />,
				},
			])}
		</>
	);
};

export default MovieInfo;
